import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { motion } from "framer-motion";
import useExpenseDepartments from "./useExpenseDepartments";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../assets/svgIcons";
import {
  ExpenseDepartmentForm,
  ExpenseDepartmentsTable,
} from "../../../../components/secondaryComponents/Expenses";
import { RoutedModal } from "../../../../components/common";

const ExpenseDepartments = () => {
  const {
    isFetchingDepartments,
    expenseDepartments,
    metaDetails,
    isCreateDepartment,
    setIsCreateDepartment,
    gotoPage,
  } = useExpenseDepartments();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Expense Departments"
      description="View all expense departments"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className={`${globalStyles.pageColumnGaps}`}>
            <div>
              <h4 className="mb-0">Departments</h4>
              <p>
                Organise and monitor your spending by managing expenses with
                departments.
              </p>
            </div>

            <div className={globalStyles.pageHeaders}>
              <p>{expenseDepartments?.length} Expense Departments</p>

              {/* <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Expense"}
                permissionChildKey="can_view_edit_and_create_expense_category"
              > */}
              <primaryComponents.Button
                classNames="btn btn--primary ml-auto"
                onClick={() => setIsCreateDepartment(true)}
              >
                <PlusIcon className="mr-1" /> Create Department
              </primaryComponents.Button>
              {/* </secondaryComponents.NavigateWithPermission> */}
            </div>

            <div className={globalStyles.tableWrapper}>
              <secondaryComponents.LoaderHelper
                isLoading={isFetchingDepartments}
                classNames="mt-5"
              >
                <ExpenseDepartmentsTable
                  expenseDepartments={expenseDepartments}
                  metaDetails={metaDetails}
                  gotoPage={gotoPage}
                />
              </secondaryComponents.LoaderHelper>
            </div>
          </div>

          <RoutedModal
            isActive={isCreateDepartment}
            headerTitle="Create Department"
            width={550}
            style={{ height: "auto" }}
            closeModal={() => setIsCreateDepartment(false)}
          >
            <ExpenseDepartmentForm
              closeModal={() => setIsCreateDepartment(false)}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default ExpenseDepartments;
